import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/toggle-switch.css'
import './lib/i18n' // Import i18n configuration

// Suppress tracking prevention warnings early
import { suppressTrackingWarnings } from './components/ads/AdUtils'
suppressTrackingWarnings()

const rootElement = document.getElementById('root')!;

// For development, always use createRoot to avoid hydration issues
// For production with react-snap, this will be handled differently
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
); 